import { render } from "./database.vue.js?vue&type=template&id=55c43404!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./database.vue?vue&type=template&id=55c43404"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__